//-- Copyright (c) 2021 TMT Insights Group, LLC
import { DashboardConfig } from '@tmt-insights/oms_fe_core';
import { addDays, startOfToday } from 'date-fns';

// COLOR OPTIONS: default = grey, error = red, warning = yellow, info = blue, success = green
const dashboardConfig: DashboardConfig = {
  // the cards along the top of the dashboard
  statusCards: [
    {
      name: 'Awaiting Assets',
      status: 'awaiting_assets',
      color: 'default',
      ignoreOnPieChart: false,

      filter: ['submit', 'awaiting_assets', 'media_ordered'],
      excludeStatus: ['cancelled', 'cancelling'],
      icon: 'clock'
    },
    {
      name: 'Edit/Conform',
      status: 'edit',
      color: 'info',
      icon: 'carbon:warning',
      ignoreOnPieChart: false,
      filter: ['ready_to_comply', 'compliance_ready_for_edit', 'compliance_in_edit', 'ready_to_recomply', 'ready_to_transform'],
      excludeStatus: ['cancelled', 'cancelling']
    },
    {
      name: 'Review',
      status: 'ready_for_review',
      color: '#DE46AF',
      ignoreOnPieChart: false,
      icon: 'ic:baseline-timelapse',
      filter: ['compliance_approval', 'recompliance_approval'],
      excludeStatus: ['cancelled', 'cancelling']
    },
    {
      name: 'Processing',
      status: 'delivering',
      color: 'warning',
      ignoreOnPieChart: false,
      filter: [
        'media_received',
        'media_ingested',
        'in_progress',
        'compliance_in_progress',
        'recompliance_in_progress',
        'transform_rating_in_progress'
      ],
      excludeStatus: ['cancelled', 'cancelling'],
      icon: 'flight'
    },
    {
      name: 'Delivered',
      status: 'completed',
      color: 'success',
      ignoreOnPieChart: true,
      filter: ['completed'],
      excludeStatus: ['cancelled', 'cancelling'],
      icon: 'check'
    }
  ],

  earliestDate: '1-1-2024',

  graphList: [
    {
      id: 'open-job-status',
      checked: true
    },
    {
      id: 'completed-jobs',
      checked: true
    },
    {
      id: 'recent-tasks',
      checked: true
    },
    {
      id: 'daily-reports',
      checked: true
    }
  ],

  graphSettings: {
    'completed-jobs': {
      displayed_job_types: ['delivery', 'compliance', 'recompliance', 'transform_rating', 'compliance_edit', 'adpress'],
      colors: ['default', '#DE46AF', '#FF9E00', '#8855ee', 'info']
    },

    'open-job-status': {
      colors: ['default', '#DE46AF', '#FF9E00', 'info']
    },

    reports: {
      asyncReports: true
    }
  },

  customizeDashboard: false,

  customCycleDates: [
    {
      id: 'my-last-7-days',
      label: 'My last 7 days',
      calculate: () => {
        const todayStart = startOfToday();
        const startDate = addDays(todayStart, -6); // last 7 days including today
        startDate.setHours(0, 0, 0, 0);

        const endDate = new Date(todayStart);
        endDate.setHours(23, 59, 59, 999);

        return {
          startDate: startDate.toISOString(),
          endDate: endDate.toISOString()
        };
      },
      queryParams: () => {
        return {
          scope: 'mine'
        };
      }
    }
  ],
  recentTasksConfig: {
    filters: {
      asset_confirmation_filter: true
    }
  }
};

export default dashboardConfig;
